module.exports = __webpack_public_path__ + "img/1.34e75699.png";